import { render, staticRenderFns } from "./RallyStart.vue?vue&type=template&id=531a651a"
import script from "./RallyStart.vue?vue&type=script&lang=ts"
export * from "./RallyStart.vue?vue&type=script&lang=ts"
import style0 from "./RallyStart.vue?vue&type=style&index=0&id=531a651a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports